import { I18nHelper, Translations } from "../../Lib/Helper/I18nHelper";
import { AxProgressBar, Step } from "../../Limestone/AxProgressBar/AxProgressBar";
import { AxLoad } from "../../Lib/AxSystem/AxLoad";
import { AxStaticConfigModule } from "../AxConfig/AxStaticConfigModule";

export class ProgressBar {
    constructor(private i18nHelper = new I18nHelper()) { }

    Init(initData: ProgressBarInit) {
        let progressBar = new AxProgressBar();

        let count = -1;
        let steps: Step[];
        
        switch (initData.Mode) {
            case ProgressBarMode.Suballotment:
                steps = this.GetSuballotmentSteps();
                break;
            case
                ProgressBarMode.Reservation:
                steps = this.GetReservationSteps();
                break;
            default:
                steps = this.GetDefaultSteps();
                break;
        }


        if (initData.Mode == ProgressBarMode.Default || initData.Mode == ProgressBarMode.Suballotment) {
            let configModule = AxLoad.GetModule<AxStaticConfigModule>('AxStaticConfigModule');

            if (configModule.skipSummary) {
                if (initData.Progress >= steps.findIndex(x => x.alias === 'summary')) {
                    initData.Progress--;
                }
                steps = steps.filter(x => x.alias !== 'summary');
            }
        }

        for (let step of steps) {
            if (count != -1) {
                if (count < initData.Progress) {
                    step.type = 'done';
                } else if (count == initData.Progress) {
                    step.type = 'active';
                } else if (count > initData.Progress) {
                    step.type = 'inactive';
                }
            }
            count++;
        }

        progressBar.Init({
            target: '.header__progressbar',
            steps: steps
        });
    }

    GetDefaultSteps(): Step[] {
        return [
            {
                label: this.i18nHelper.GetTranslation(Translations.Ticket),
                type: 'done'
            },
            {
                label: this.i18nHelper.GetTranslation(Translations.QuantityDate),
                type: 'active'
            },
            {
                label: this.i18nHelper.GetTranslation(Translations.Summary),
                type: 'inactive',
                alias: 'summary'
            },
            {
                label: this.i18nHelper.GetTranslation(Translations.CartCart),
                type: 'inactive'
            },
            {
                label: this.i18nHelper.GetTranslation(Translations.Checkout),
                type: 'inactive'
            }
        ];
    }

    GetSuballotmentSteps(): Step[] {
        return [
            {
                label: this.i18nHelper.GetTranslation(Translations.Ticket),
                type: 'done'
            },
            {
                label: this.i18nHelper.GetTranslation(Translations.QuantityDate),
                type: 'active'
            },
            {
                label: this.i18nHelper.GetTranslation(Translations.Timings),
                type: 'inactive'
            },
            {
                label: this.i18nHelper.GetTranslation(Translations.Summary),
                type: 'inactive',
                alias: 'summary'
            },
            {
                label: this.i18nHelper.GetTranslation(Translations.CartCart),
                type: 'inactive'
            },
            {
                label: this.i18nHelper.GetTranslation(Translations.Checkout),
                type: 'inactive'
            }
        ];
    }

    GetReservationSteps(): Step[] {
        return [
            {
                label: this.i18nHelper.GetTranslation(Translations.TicketVerification),
                type: 'active'
            },
            {
                label: this.i18nHelper.GetTranslation(Translations.ReservationManagement),
                type: 'inactive'
            },
            {
                label: this.i18nHelper.GetTranslation(Translations.DateTimeReservation),
                type: 'inactive'
            },

        ];
    }
}

export interface ProgressBarInit {
    Progress: number;
    Mode: ProgressBarMode
}

export enum ProgressBarMode {
    Default,
    Suballotment,
    Reservation
}